module.exports = __webpack_public_path__ + "images/pages/for_business/pc/head_641089dcf8a2d46d8d0b3a778cb9e125.jpg";